const React = require('react');
const { Provider } = require('react-redux');
const store = require('Store');
const BaseClass = require('components/BaseClass/BaseClass');
const wrapUFE = require('utils/framework/wrapUFE');

class ReduxProvider extends BaseClass {
    static class = 'ReduxProvider';

    static displayName = 'ReduxProvider';

    render() {
        const { children } = this.props;
        return (
            <Provider store={store}>
                {children}
            </Provider>
        );
    }
}

module.exports = wrapUFE(ReduxProvider);
